import { defineMessages } from "@formatjs/intl";
export default defineMessages({
  youAreViewingAsTypography: {
    id: "schoolAdmin.youAreViewingAsTypography",
    defaultMessage: "You are viewing as"
  },
  backToAdminAccountLabel: {
    id: "schoolAdmin.backToAdminAccountLabel",
    defaultMessage: "Back to Admin account"
  },
  removeRelatedCoursesError: {
    id: "schoolAdmin.removeRelatedCoursesError",
    defaultMessage: "You cannot delete the class without removing the following related courses:"
  },
  classHasStudentsError: {
    id: "schoolAdmin.classHasStudentsError",
    defaultMessage: "You cannot delete the class that has students"
  },
  classHasCertificatesError: {
    id: "schoolAdmin.classHasCertificatesError",
    defaultMessage: "You cannot delete the class that has certificates"
  },
  noPermission: {
    id: "schoolAdmin.noPermission",
    defaultMessage: "You don't have permission"
  }
});